import * as React from "react";

import { Confirm, Product } from "./Chapters";

export default (key, method) => {
  switch (key) {
    case "PRODUCT":
      return <Product {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
